import React from "react";
import Select from "react-select";
import { withStyles, Grid } from "@material-ui/core";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { uniqBy } from "lodash";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Clear from "@material-ui/icons/CancelOutlined";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styles from "./styles";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { isValid as isDateTimeValid, format } from "date-fns";
import { getUTCDate } from "../../../dataGrid/gridUtilities";
import InputAdornment from "@material-ui/core/InputAdornment";
import constants from "./constants";

class IBPlanningSummaryFilters extends React.Component {
  constructor(props) {
    super(props);
    this.allRegions = [];
    this.allDivisions = [];
    this.allTerminals = [];
    this.PLAN_DATE_FORMAT = "yyyy-MM-dd";
    this.state = {
      status: ["Data Not Received", "Not Published", "Published"],
      selectedRegion: [],
      selectedTerminal: [],
      selectedDivision: [],
      checkedStatus: [],
      region: [],
      terminals: [],
      divisions: [],
      publishedTerminalCount: 0,
      terminalCount: 0,
      filteredData: [],
      date: null
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.length && this.props.data !== prevProps.data) {
      this.updateDropdowns();
    }
  }

  //update the values in the card whenever data is getting updated
  updateCardValues = data => {
    const publishedTerminalCount = data.filter(
      terminals => terminals.publishCount > 0
    ).length;
    const terminalCount = data.filter(terminals => terminals.firstPush !== null)
      .length;
    this.setState({
      publishedTerminalCount,
      terminalCount
    });
  };

  //populate the data in all the filter components (dropdown)
  updateDropdowns = () => {
    const { data } = this.props;
    const date = getUTCDate(
      this.props.data.length ? this.props.data[0].planDate : new Date()
    );

    this.updateCardValues(data);
    this.allRegions = this.constructOption(data, "regionName");
    this.allTerminals = this.constructOption(data, "terminalCode");
    this.allDivisions = this.constructOption(data, "divisionName");
    this.setState({
      regions: uniqBy(this.allRegions, "regionName"),
      terminals: uniqBy(this.allTerminals, "terminalCode"),
      divisions: uniqBy(this.allDivisions, "divisionName"),
      filteredData: data,
      date
    });
  };

  constructOption(list, field) {
    const option = list.map(data => ({
      label: data[field],
      value: data[field],
      ...data
    }));
    return option;
  }

  //if no filter is applied, then update the UI with all the data
  checkNoFilterApplied = () => {
    const {
      selectedDivision,
      selectedTerminal,
      selectedRegion,
      checkedStatus
    } = this.state;
    if (
      !selectedDivision.length &&
      !selectedTerminal.length &&
      !selectedRegion.length &&
      !checkedStatus.length
    ) {
      this.updateDropdowns();
    }
  };

  //check if any status is selected or not
  isAnyStatusChecked = data => {
    const { checkedStatus } = this.state;
    return (
      !checkedStatus.length ||
      checkedStatus.some(checkedValue => {
        if (checkedValue === "Published") return data.publishCount;
        else if (checkedValue === "Not Published")
          return data.firstPush && !data.publishCount;
        else if (checkedValue === "Data Not Received") return !data.firstPush;
      })
    );
  };

  isIncludes = (data, fieldName, selectedDropdown) => {
    return (
      !selectedDropdown.length || selectedDropdown.includes(data[fieldName])
    );
  };

  //update all the dropdown options when any filter is applied
  updateAllDropdownOptions = () => {
    const {checkedStatus} = this.state;
    
    const selectedDivision = this.state.selectedDivision.map(division=>division.value);
    const selectedTerminal = this.state.selectedTerminal.map(terminal=>terminal.value);
    const selectedRegion = this.state.selectedRegion.map(region=>region.value);

    let divisions,
      regions,
      terminals = [];

    divisions =
      !selectedRegion.length &&
      !selectedTerminal.length &&
      !checkedStatus.length
        ? this.allDivisions
        : this.allDivisions.filter(
            division =>
              this.isIncludes(division, "regionName", selectedRegion) &&
              this.isIncludes(division, "terminalCode", selectedTerminal) &&
              this.isAnyStatusChecked(division)
          );

    regions =
      !selectedDivision.length &&
      !selectedTerminal.length &&
      !checkedStatus.length
        ? this.allRegions
        : this.allRegions.filter(
            region =>
              this.isIncludes(region, "divisionName", selectedDivision) &&
              this.isIncludes(region, "terminalCode", selectedTerminal) &&
              this.isAnyStatusChecked(region)
          );

    terminals =
      !selectedDivision.length &&
      !selectedRegion.length &&
      !checkedStatus.length
        ? this.allTerminals
        : this.allTerminals.filter(
            terminal =>
              this.isIncludes(terminal, "divisionName", selectedDivision) &&
              this.isIncludes(terminal, "regionName", selectedRegion) &&
              this.isAnyStatusChecked(terminal)
          );

    const filteredData = this.props.data.filter(
      data =>
        this.isIncludes(data, "divisionName", selectedDivision) &&
        this.isIncludes(data, "regionName", selectedRegion) &&
        this.isIncludes(data, "terminalCode", selectedTerminal) &&
        this.isAnyStatusChecked(data)
    );

    this.updateCardValues(filteredData);

    this.setState({
      divisions: uniqBy(divisions, "divisionName"),
      regions: uniqBy(regions, "regionName"),
      terminals: uniqBy(terminals, "terminalCode"),
      filteredData
    });

    this.checkNoFilterApplied();
    this.props.updatePublishedTerminals(filteredData); //for updating the grid
  };

  handleDropdownChange = (selectedValue, event) => {
    const { name } = event;
    this.setState(
      {
        [name]: selectedValue
      },
      this.updateAllDropdownOptions
    );
  };

  handleStatusChange = data => {
    this.setState(
      state => ({
        checkedStatus: state.checkedStatus.includes(data)
          ? state.checkedStatus.filter(status => status !== data)
          : [...state.checkedStatus, data]
      }),
      this.updateAllDropdownOptions
    );
  };

  resetSelectedValues = () => {
    this.setState({
      selectedTerminal:[],
      selectedDivision:[],
      selectedRegion:[],
      checkedStatus:[]
    })
  }

  getMaxPlanDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + constants.MAX_DATE_RANGE_LIMIT);
    return d;
  };

  onDateChanged = date => {
    const planDate = format(date, this.PLAN_DATE_FORMAT);
    if (isDateTimeValid(date) && this.state.date !== date) {
      this.props.getPublishedTerminals(planDate);
      this.resetSelectedValues();
    }
    this.setState({
      date
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container spacing={24} className={classes.container}>
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              <header>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    ref={node => {
                      this.picker = node;
                    }}
                    autoOk
                    format={"iiii, LLLL dd, yyyy"}
                    onChange={this.onDateChanged}
                    value={this.state.date}
                    maxDate={this.getMaxPlanDate()}
                    className={classes.datePickerInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarTodayIcon
                            onClick={() => this.picker.open()}
                          />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.inputRoot
                      }
                    }}
                  />
                </MuiPickersUtilsProvider>
              </header>
              <div>
                <div className={classes.cardContent}>
                  <p className={classes.data}>
                    {this.state.filteredData.length}
                  </p>
                  Total Activated Terminals
                </div>
                <div className={classes.cardContent}>
                  <p className={classes.data}>{this.state.terminalCount}</p>
                  Terminals Received Data from AS400
                </div>
                <div className={classes.cardContent}>
                  <p className={classes.data}>
                    {this.state.publishedTerminalCount}
                  </p>
                  Terminals Published back to AS400
                </div>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={12} lg={6}>
          <p className={classes.formLabel}>Search by Terminal</p>
          <Select
            isMulti
            name="selectedTerminal"
            classNamePrefix={"select"}
            className={`${classes.reactSelect} ${
              Array.isArray(this.state.value) && this.state.value.length > 0
                ? classes.multiValueApplied
                : ""
            }`}
            value={this.state.selectedTerminal}
            onChange={this.handleDropdownChange}
            options={this.state.terminals}
            closeMenuOnSelect={false}
            components={{
              DropdownIndicator: props => (
                <ArrowDropDown
                  {...props.innerProps}
                  className={classes.iconStyle}
                />
              ),
              ClearIndicator: props => (
                <Clear {...props.innerProps} className={classes.iconStyle} />
              )
            }}
          />
          <br />
          <p className={classes.formLabel}>Search by Region</p>
          <Select
            isMulti
            name="selectedRegion"
            classNamePrefix={"select"}
            className={`${classes.reactSelect} ${
              Array.isArray(this.state.value) && this.state.value.length > 0
                ? classes.multiValueApplied
                : ""
            }`}
            value={this.state.selectedRegion}
            onChange={this.handleDropdownChange}
            options={this.state.regions}
            closeMenuOnSelect={false}
            components={{
              DropdownIndicator: props => (
                <ArrowDropDown
                  {...props.innerProps}
                  className={classes.iconStyle}
                />
              ),
              ClearIndicator: props => (
                <Clear {...props.innerProps} className={classes.iconStyle} />
              )
            }}
          />
          <br />
          <p className={classes.formLabel}>Search by Division</p>
          <Select
            isMulti
            name="selectedDivision"
            classNamePrefix={"select"}
            className={`${classes.reactSelect} ${
              Array.isArray(this.state.value) && this.state.value.length > 0
                ? classes.multiValueApplied
                : ""
            }`}
            value={this.state.selectedDivision}
            onChange={this.handleDropdownChange}
            options={this.state.divisions}
            closeMenuOnSelect={false}
            components={{
              DropdownIndicator: props => (
                <ArrowDropDown
                  {...props.innerProps}
                  className={classes.iconStyle}
                />
              ),
              ClearIndicator: props => (
                <Clear {...props.innerProps} className={classes.iconStyle} />
              )
            }}
          />
        </Grid>
        <Grid item md={12} lg={5}>
          <FormControl>
            <FormLabel className={classes.formLabel} focused={false}>
              Search by Status
            </FormLabel>
            {this.state.status.map((data, index) => {
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon />}
                      checkedIcon={<CheckBoxIcon />}
                      classes={{
                        root: classes.root,
                        checked: classes.checked
                      }}
                    />
                  }
                  label={data}
                  onChange={() => this.handleStatusChange(data)}
                  checked={this.state.checkedStatus.includes(data)}
                  classes={{ label: classes.label }}
                />
              );
            })}
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.warningNote}>*Note: All times are in EST</div>
        </Grid>
      </Grid>
    );
  }
}
export default withStyles(styles)(IBPlanningSummaryFilters);
